import BaseCheckbox from 'components/Form/Base/BaseCheckbox';
import {FormContextBoolean, RequiredRules} from 'components/Form/types';
import {getRegisterRules} from 'components/Form/utils';
import TooltipWrapper from 'components/Tooltip';
import useFormError from 'hooks/useFormErrors';
import {FC, InputHTMLAttributes, ReactNode} from 'react';
import {useFormContext} from 'react-hook-form';

export type CheckboxProps<T = HTMLInputElement> = {
    disabledReason?: string;
    helpText?: ReactNode;
    label?: ReactNode;
    name: string;
    type?: never;
} & RequiredRules<InputHTMLAttributes<T>>;

const Checkbox: FC<CheckboxProps> = ({
    className,
    disabled,
    disabledReason,
    helpText,
    name,
    required,
    rules,
    ...rest
}) => {
    const {register} = useFormContext<FormContextBoolean>();

    const fieldError = useFormError(name);

    const registerRules = getRegisterRules({disabled, required, rules});

    const checkbox = (
        <BaseCheckbox
            className={className}
            error={fieldError}
            helpText={helpText}
            required={!!registerRules?.required}
            {...register(name, registerRules)}
            {...rest}
        />
    );

    return disabled && disabledReason ? (
        <TooltipWrapper message={disabledReason}>{checkbox}</TooltipWrapper>
    ) : (
        checkbox
    );
};

export default Checkbox;
